import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modele-document',
  templateUrl: './modele-document.component.html',
  styleUrls: ['./modele-document.component.scss']
})
export class ModeleDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
